import React from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PostOfTheWeek = ({ post, onCopy, onDownload }) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-sm">
      <div className="px-4 py-3 md:px-6 md:py-4 border-b border-border bg-white" style={{ backgroundColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.05)))' }}>
        <div className="flex items-center gap-2">
          <Icon name="Star" size={20} className="text-primary" />
          <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">Post of the Week</h2>
        </div>
        <p className="text-xs md:text-sm text-muted-foreground mt-1 font-caption">Featured content ready to share</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 p-4 md:p-6">
        <div className="relative aspect-square lg:aspect-[4/3] rounded-lg overflow-hidden bg-muted">
          <Image
            src={post?.image}
            alt={post?.imageAlt}
            className="w-full h-full object-cover" />

          <div className="absolute top-3 right-3 bg-primary px-3 py-1 rounded-full text-xs font-medium text-primary-foreground">
            {post?.platform}
          </div>
        </div>

        <div className="flex flex-col justify-between">
          <div>
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-2 md:mb-3">
              {post?.title}
            </h3>
            <div className="bg-muted/50 rounded-lg p-3 md:p-4 mb-3 md:mb-4">
              <p className="text-sm md:text-base text-foreground whitespace-pre-line line-clamp-6">
                {post?.caption}
              </p>
            </div>
            <div className="flex flex-wrap gap-2 mb-4">
              {post?.hashtags?.map((tag, index) =>
              <span
                key={index}
                className="text-xs md:text-sm px-2 py-1 rounded bg-muted text-foreground"
              >

                  {tag}
                </span>
              )}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
            <Button
              variant="outline"
              onClick={() => onCopy(post?.caption)}
              iconName="Copy"
              iconPosition="left"
              fullWidth
              className="sm:flex-1">

              Copy Caption
            </Button>
            <Button
              variant="default"
              onClick={() => onDownload(post?.image, post?.title)}
              iconName="Download"
              iconPosition="left"
              fullWidth
              className="sm:flex-1">

              Download Image
            </Button>
          </div>
        </div>
      </div>
    </div>);

};

export default PostOfTheWeek;